// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3WI61","buttons":"SendReceipts_buttons__3bm8_","email":"SendReceipts_email__1jLea","bookApptTitle":"SendReceipts_bookApptTitle__icXg1"};